import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { BrowserMultiFormatReader, IScannerControls } from '@zxing/browser';

@Component({
  selector: 'app-scan-barcode',
  standalone: false,
  templateUrl: './scan-barcode.component.html',
  styleUrl: './scan-barcode.component.css',
})
export class ScanBarcodeComponent implements OnDestroy {
  barcode: string = '';
  @ViewChild('video') videoElementRef!: ElementRef<HTMLVideoElement>;
  @Output() scannedBarcode = new EventEmitter<string>();

  // Barcode scanner variables and methods
  result: string | null = null;
  scanning = false;

  private readonly codeReader = new BrowserMultiFormatReader();
  private stream: MediaStream | null = null;
  private videoElement: HTMLVideoElement | null = null;
  private controls: IScannerControls | null = null;

  async toggleScan() {
    if (this.scanning) {
      this.stopScan();
    } else {
      this.scanning = true;
      setTimeout(() => {
        this.startScan();
      });
    }
  }

  private async startScan() {
    this.videoElement = this.videoElementRef.nativeElement;
    this.result = null;

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });

      this.videoElement.srcObject = this.stream;

      // safer playback
      await this.videoElement.play().catch(() => {});

      this.controls = await this.codeReader.decodeFromVideoDevice(
        undefined,
        this.videoElement,
        (result, err) => {
          if (result) {
            this.barcode = result.getText();
            this.scannedBarcode.emit(this.barcode);
            this.result = null; // reset result to allow further scans
            this.stopScan();
          }
        },
      );
    } catch (error) {
      console.error('Camera error:', error);
      this.scanning = false;
    }
  }

  private stopScan() {
    if (this.controls) {
      this.controls.stop();
      this.controls = null;
    }

    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
      this.stream = null;
    }

    if (this.videoElement) {
      this.videoElement.style.display = 'none';
    }

    this.scanning = false;
  }

  ngOnDestroy() {
    this.stopScan();
  }
}
